import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

export const attendanceViewCroTableHead = ({ setModalState, month }) => {
  const today = dayjs()
    .month(month?.id - 1)
    .daysInMonth();

  return [
    // { field: 'sl_no', headerName: 'Sl No.', width: 120 },
    { field: 'student_name', headerName: 'Student', width: 200 },
    { field: 'full_name', headerName: 'Trainer', width: 200 },
    { field: 'course_name', headerName: 'Course', width: 180 },
    // based on date dynamic header
    ...Array.from({ length: today }).map((_, i) => ({
      field: `day${i + 1}`,
      headerName: `${i + 1}`,
      width: 100,
      renderCell: ({ row, value, field }) => (
        <Typography
          variant="inherit"
          sx={{
            cursor: 'pointer',
          }}
          onClick={(e) => {
            setModalState({
              actionKey: 'Daily View',
              row: { ...row, date: field.slice(3).padStart(2, '0') },
            });
          }}
        >
          {value}
        </Typography>
      ),
    })),
    //----------------------------
    { field: 'count', headerName: 'Count', width: 100 },
  ];
};

export const dailyViewTableHead = [
  { field: 'attendance_date', headerName: 'Date', width: 180 },
  { field: 'from_time', headerName: 'From Time', width: 130 },
  { field: 'to_time', headerName: 'To Time', width: 130 },
  { field: 'subject_name', headerName: 'Subject', width: 180 },
  { field: 'lessons', headerName: 'Lessons', width: 200 },
  { field: 'trainer_remarks', headerName: 'Remarks', width: 220 },
  { field: 'attendance_timestamp', headerName: 'Timestamp', width: 180 },
];
